import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentBG = props => {
    return <Aux>
        <SectionHeading priority={1} text='Защо да изберем "Юра"?' />
        <ul>
            <li>Нискоетажна сграда, която е в хармония със заобикалящата я среда и отговаря на представите и изискванията за имот с високи стандарти на строителство и ексклузивност.</li>
            <li>Големи апартаменти с отлично изложение от 74 до 300 кв.м.</li>
            <li>Изключително комуникативно място - до бул."Васил Левски" и бул."Княз Борис I" с достъп до градския транспорт във всички направления.</li>
            <li>Близост до елитни учебни заведения </li>
            <li>Сградата граничи с два парка</li>
            <li>Топ локация – престижен квартал</li>
            <li>Сградата е съобразена с всички изисквания за енергийна ефективност клас А</li>
            <li>Отлична звукоизолация</li>
            <li>Решен е проблемът с паркирането. </li>
            <li>Инсталационен достъп до интернет и кабелна телевизия.</li>
            <li>Подготовка за климатизация.</li>
            <li>Подготовка за газоснабдяване.</li>
            <li>Малко на брой апартаменти във вход – малко съседи за добър жилищен комфорт.</li>
            <li>Цялостната визия и добрият облик на сградата. Имотът е проектиран според последните тенденции в архитектурата и съвременните конструктивни изисквания.</li>
            <li>Налагането на висок стандарт, контрол и гаранции на завършеност.</li>
        </ul>
    </Aux>
}

export default ContentBG



// WEBPACK FOOTER //
// ./src/routes/WhyJura/components/ContentBG.js